
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.674 25.302L18.084 3.267a2.394 2.394 0 00-4.169 0L1.326 25.302c-.926 1.621.23 3.648 2.085 3.648h25.178c1.854 0 3.011-2.026 2.085-3.648zm-2.085 1.419H3.411a.202.202 0 01-.175-.305l12.59-22.035a.2.2 0 01.348 0l12.59 22.034a.202.202 0 01-.175.305v.001z"}}),_c('path',{attrs:{"d":"M16 11.295c-.61 0-1.103.5-1.103 1.115v6.388c0 .616.494 1.114 1.103 1.114.61 0 1.103-.498 1.103-1.114V12.41c0-.615-.494-1.114-1.103-1.114zm0 10.065c-.61 0-1.103.5-1.103 1.115v.665c0 .616.494 1.115 1.103 1.115.61 0 1.103-.5 1.103-1.115v-.665c0-.616-.494-1.115-1.103-1.115z"}})])
          )
        }
      }
    